/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Terms_P1Inputs */

const en_register_onboarding_terms_p1 = /** @type {(inputs: Register_Onboarding_Terms_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I agree that my information within the framework of Matching Week 2026 will be used for an automated matching with company profiles. My resume and my profile will be made available exclusively to the companies and positions I have selected.`)
};

const de_register_onboarding_terms_p1 = /** @type {(inputs: Register_Onboarding_Terms_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich bin damit einverstanden, dass meine Angaben im Rahmen der Matching Week 2026 für ein automatisiertes Matching mit Unternehmensprofilen verwendet werden. Mein Lebenslauf und mein Profil werden ausschließlich den von mir ausgewählten Unternehmen und Stellen zur Verfügung gestellt.`)
};

/**
* | output |
* | --- |
* | "I agree that my information within the framework of Matching Week 2026 will be used for an automated matching with company profiles. My resume and my profile..." |
*
* @param {Register_Onboarding_Terms_P1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_terms_p1 = /** @type {((inputs?: Register_Onboarding_Terms_P1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Terms_P1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_terms_p1(inputs)
	return en_register_onboarding_terms_p1(inputs)
});